import {
  AuthService,
  FooterComponent,
  GoogleAnalyticsService,
  LoadingIndicatorComponent,
  NavbarComponent,
  NotificationsComponent,
  SessionService,
  TermsAndConditionService,
} from '@accesso/adk-portal-shared';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { SidebarComponent } from './components/layout/sidebar/sidebar.component';
import { UserRoleDirective } from './shared/directives/user-role.directive';
import { UserGroups } from './shared/models/user.model';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [],
    imports: [RouterOutlet, LoadingIndicatorComponent, NavbarComponent, FooterComponent, SidebarComponent, UserRoleDirective, NotificationsComponent]
})
export class AppComponent implements OnInit, OnDestroy {
  private authService = inject(AuthService);
  private termsAndConditionService = inject(TermsAndConditionService);
  private sessionService = inject(SessionService);
  private googleAnalyticsService = inject(GoogleAnalyticsService);

  isUserLoggedIn = false;
  isTermsAccepted = false;
  allowedRoles = [UserGroups.OWNER, UserGroups.SUPER_ADMIN, UserGroups.PRODUCT_ADMIN, UserGroups.CLIENT_ADMIN];
  private loggedInSubscription: Subscription | undefined;
  private termsAcceptedSubscription: Subscription | undefined;
  ngOnInit() {
    this.isUserLoggedIn = this.authService.isLoggedIn;
    this.loggedInSubscription = this.authService.getLoggedInEvent().subscribe((loggedIn) => {
      this.isUserLoggedIn = loggedIn;
      if (loggedIn) {
        this.sessionService.setupSessionRenewal();
      }
    });
    this.termsAcceptedSubscription = this.termsAndConditionService.getTermsAndConditionAcceptanceEvent().subscribe((accepted) => {
      this.isTermsAccepted = accepted;
    });
    this.googleAnalyticsService.initialize();
  }

  ngOnDestroy(): void {
    this.loggedInSubscription?.unsubscribe();
    this.termsAcceptedSubscription?.unsubscribe();
  }
}
